import * as Sentry from '@sentry/react';

export const captureException = Sentry.captureException;
